import { render, staticRenderFns } from "./UsagePoliciesPage.vue?vue&type=template&id=d0e5984a&scoped=true&"
import script from "./UsagePoliciesPage.vue?vue&type=script&lang=js&"
export * from "./UsagePoliciesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e5984a",
  null
  
)

export default component.exports